<template lang="pug">
    v-card.mark-card.portal-drawer-dialog(:height="windowHeight" :max-height="windowHeight" elevation='0' v-if='currentReference').portaldrawerDialog
        //- All References(prop data type is array)
        template(v-if='Array.isArray(currentReference)')
            v-card-title.d-flex.justify-between-space.align-start.px-0.pb-0(:class="isUpsideExtension ? 'pt-3':'pt-0'" style='border-bottom: 1px solid #E8E8E8; height: 63px;')
                v-col.closeBtn()
                    v-btn.close-line.btn-none-effect(icon @click='onCloseDialog' tile :ripple="false")
                        v-icon(size='35') mdi-chevron-left
                    span.ml-2 {{currentReference.length}} {{$t("PORTAL.REFERENCE")}}
                v-col(cols="auto")
                    v-btn(icon @click='onCloseDialog')
                        v-icon mdi-close
            v-card-actions.d-flex.justify-center.px-2
                v-row.d-flex.flex-nowrap.justify-space-between
                    v-col.px-0.pt-2.pb-1(cols='6')
                        v-chip-group.mt-1.pl-2()
                            v-btn.mr-3.pa-0(v-for="ref_ in reffilters" :key="ref_.key" :class="ref_.active?'reffilter-active':'reffilter-default'" max-height="24" min-width="29" rounded depressed @click="toggleTypeFilters(ref_)")
                                span(v-if="ref_.key == 'all'" :style="ref_.active?'font-size:10px; font-Family:Segoe UI; font-Weight:400; color:#2571C7;':'font-size:10px; font-Family:Segoe UI; font-Weight:400; color:#888888;'") {{ref_.name}}
                                v-avatar(v-if="ref_.key == 'web'")
                                    v-img(src="@/assets/images/search_web.svg" max-width="16px" max-height="16px")
                                    span.ml-1(v-if="ref_.key == 'web'" :style="ref_.active?'font-size:12px; font-Family:Segoe UI; font-Weight:400; color:#2571C7;':'font-size:12px; font-Family:Segoe UI; font-Weight:400; color:#888888;'") {{web_ref_count}}
                                v-avatar(v-if="ref_.key == 'knowledge'")
                                    v-img(src="@/assets/images/knowledge_select.svg" max-width="16px" max-height="16px")
                                    span.ml-1(v-if="ref_.key == 'knowledge'" :style="ref_.active?'font-size:12px; font-Family:Segoe UI; font-Weight:400; color:#2571C7;':'font-size:12px; font-Family:Segoe UI; font-Weight:400; color:#888888;'") {{kb_ref_count}}
                    v-col.px-0.pt-2.pb-1(cols='6')
                        v-btn.portal-btn-black.pa-0.pl-15(v-show="showRemoveBtn" :ripple='false' @click='onRemoveChunks("Multi")' width='100%' height='40' color="transparent" depressed dark :disabled='changeReference.length==0')
                            v-icon(size='18') icon-remove
                            span Remove Reference
            div.pl-4.pr-3.py-4.mt-0.ref-content(style="overflow-y: auto; max-height: 80vh;")
                v-row.mb-3(:class='')
                    v-col.px-0.pt-1.pb-2(cols='12' v-for="(reference) in filteredReferences" :key="reference.context_id")
                        v-card.reference-card.mark-card.pt-2.px-2.pb-3(:ripple="false" :elevation='0' @click='getDetailReference(selectedQuestionid,reference.context_id)' )
                            v-card-title.flex-nowrap.pa-0.d-flex.align-center
                                v-avatar.mark.mx-1.mb-1.px-0( size='16' tile)
                                    span(style='font-size:10px; color:#666; padding-bottom:1px;') {{reference.context_id}}
                                span.ml-2.mb-1.textx-subtitle-2.font-weight-bold.ellipsis(:title='reference.title?reference.title:reference.filename') {{reference.title?reference.title:reference.filename}}
                                v-spacer
                                v-checkbox.mr-2(v-show="showRemoveBtn"  dense color='#18bedf' multiple v-model='changeReference' :value='reference' @click.stop )
                            v-card-text.pt-0.pb-0.pl-7(v-if="reference.display_type=='IMAGE'")
                                img.source_image(v-if="reference.doc_image_urls && reference.doc_image_urls[0] && reference.doc_image_urls[0].doc_image_url" :src='reference.doc_image_urls[0].doc_image_url' width='100%' height='auto' @error="handleImageError" :draggable="!disableCopy" style="aspect-ratio:16/9; object-fit:cover; max-width:55%; border-radius:5%;" alt='reference image')
                                img.mb-1.source_image(v-else :src='errorbackImage' width='45' height='auto' :draggable="!disableCopy" style="aspect-ratio:16/9; object-fit:cover; border-radius:3px;" alt='Not image avaiable')
                            v-card-text.pt-0.pb-0.pl-7(v-else)
                                p {{reference.cut_content}}
                            v-card-text.d-flex.ellipsis.pl-0.pr-2.pb-1(:class="reference.display_type=='IMAGE'?'pt-3':''")
                                v-avatar.ml-2(v-if="reference.chunk_id == 'bing_search_result'" color='white' size='17' rounded="100" style='margin-top: 2px;')
                                    //- v-icon(size='14' color='#444') mdi-cloud-search-outline
                                    img(:src="getWebIcon(reference.cloud_url)" max-width="17px" @error="onWebIconImgError")
                                v-avatar.ml-2(v-else :color="getColorFromKnowledgeName(reference.knowledge_lib_name)" size='17' rounded="100"  :title="reference.knowledge_lib_name" style='margin-top: 2px;')
                                    span(style='font-size:10px; padding-bottom:2px;' ) {{reference.knowledge_lib_name.slice(0,1)}}
                                span.pl-2.file(:title="reference.filename") {{reference.filename}}
                                v-spacer
                                v-chip(flat) {{reference.score_percentage}}%
                            v-card-text.ellipsis.pa-0.pl-0.pb-1(v-if="reference.chunk_id == 'bing_search_result'" style="margin-top: -10px;")
                                span(:title="reference.cloud_url" style='color:#666; padding-left: 34px;') {{reference.cloud_url}}

        //- Single Reference(prop data type is object)
        template(v-else)
            v-card-title.d-flex.justify-between-space.align-start.px-0.pb-0(:class="isUpsideExtension ? 'pt-3':'pt-0'" style='border-bottom: 1px solid #E8E8E8; height: 63px;')
                v-col.closeBtn.pr-0(cols="auto")
                    v-btn.close-line.btn-none-effect(icon @click='onCloseDialog' tile :ripple="false")
                        v-icon(size='35') mdi-chevron-left
                v-col.pl-0
                    span.ellipsis-single.ml-2(:title="currentReference.filename") {{currentReference.filename}}
                v-col(cols="auto")
                    v-btn(icon @click='onCloseDialog')
                        v-icon mdi-close
            v-card-actions.d-flex.justify-center.px-2.py-1.my-2
                v-row.d-flex.flex-nowrap.justify-end
                    div.px-0()
                        v-btn.portal-btn-black.pl-0( v-show = "currentReference.iscopy && !disableCopy" :ripple='false' @click='copyAnswer(currentReference.content)' width='100%' height='40' color="transparent" depressed dark)
                            v-img(v-if='!copied' src="@/assets/images/copy.svg" max-width="15px" width="15px")
                            v-img(v-else src="@/assets/images/copied.svg" max-width="15px" width="15px")
                            span.pl-1(v-if='!copied') Copy
                            span.pl-1(v-else) Copied
                    div.px-0.ml-2()
                        v-btn.portal-btn-black.pl-0(v-if='currentReference.cloud_url !== "" ' :ripple='false' @click='onOpen(currentReference.cloud_url)' width='100%' height='40' color="transparent" depressed dark)
                            v-img(src="@/assets/images/open-icon.svg" max-width="18px" width="18px")
                            span.pl-1 Open
                    div.px-0.ml-2()
                        v-btn.portal-btn-black.pl-0(v-show="showRemoveBtn" :ripple='false' @click='onRemoveChunks("Single")' width='100%' height='40' color="transparent" depressed dark)
                            v-icon(size='18') icon-remove
                            span Remove Reference
            v-card-title.flex-nowrap.py-0.d-flex.align-start.ellipsis.mb-2(:class="{'can-select-text': !disableCopy}")
                v-avatar.mark.ml-1(style='margin-top:7px;' size='20' tile)
                    span(style='font-size:10px;') {{currentReference.context_id}}
                div.ml-2.font-weight-bold.text-wrap(:title='currentReference.title?currentReference.title:currentReference.filename') {{currentReference.title?currentReference.title:currentReference.filename}}
            v-card-title.py-0.mb-0(:class="{'can-select-text': !disableCopy}" v-if='currentReference.page_num&&currentReference.page_num.length>0')
                span.pl-1.d-flex.align-center(style='font-size:12px; font-weight:500;')
                    v-img.pr-1(src="@/assets/images/book-mark.svg" max-width="20px" height="20px")
                    span Page {{currentReference.page_num[0]}}
                    span(v-if="currentReference.page_num[0] !== currentReference.page_num[currentReference.page_num.length-1]") - {{currentReference.page_num[currentReference.page_num.length-1]}}
            //- In display type is TEXT UI fix bolck in window
            v-card-text.px-5.answer-line-height.ref-content.source-type-text-content(:class="{'can-select-text': !disableCopy}" v-if="currentReference.display_type=='TEXT'" style="overflow-y: auto; max-height: 73vh;")
                div(v-html='compiledMarkdown')
                div(v-if="currentReference.chunk_id == 'bing_search_result'" @click='onOpen(currentReference.cloud_url)' style='cursor:pointer;')
                    v-card-text.pa-0.pl-0.pb-1()
                        span(:title="currentReference.cloud_url" style='color:#444;') {{$t("PORTAL.WEB_SOURCE")}}
                    v-card-text.d-flex.ellipsis-single.pl-0.pr-2.pb-1(style="margin-top: -15px;")
                        v-avatar.ml-0(color='white' size='17' rounded="100" style='margin-top: 2px;')
                            //- v-icon(size='14' color='#444') mdi-cloud-search-outline
                            img(:src="getWebIcon(currentReference.cloud_url)" max-width="17px" @error="onWebIconImgError")
                        span.pl-2.ellipsis-single(:title="currentReference.filename") {{currentReference.filename}}
                    v-card-text.ellipsis-single.pa-0.pl-0.pb-1(style="margin-top: -6px;")
                        span(:title="currentReference.cloud_url" style='color:#666; padding-left: 28px;') {{currentReference.cloud_url}}
                v-row.image-only-container.px-4.pt-2(v-if="currentReference.doc_image_urls.length>0" :class="showSingleImage?'expanded':''")
                    v-col.py-0.d-flex.justify-end(cols='12' style='')
                        v-btn.portal-btn-black.px-0(@click='viewSingleImage(true)' icon plain)
                            v-img(v-if="showSingleImage && !closeImage" src="@/assets/images/picture-single.png" max-width="20px" width="20px" style='filter: brightness(10%) contrast(200%);')
                            v-img(v-else src="@/assets/images/picture-single.png" max-width="20px" width="20px")
                            div.btn-overlay(v-if="showSingleImage && !closeImage")
                        v-btn.portal-btn-black.px-0(v-if="currentReference.doc_image_urls.length>1" @click='viewSingleImage(false)' icon plain)
                            v-img(v-if="!showSingleImage && !closeImage" src="@/assets/images/picture-multi.png" max-width="20px" width="20px" style='filter: brightness(10%) contrast(200%);')
                            v-img(v-else src="@/assets/images/picture-multi.png" max-width="20px" width="20px")
                            div.btn-overlay(v-if="!showSingleImage && !closeImage")
                        v-btn.portal-btn-black.px-0(@click='closeImageArea()' icon plain)
                            v-img(v-if="closeImage" src="@/assets/images/picture-close.png" max-width="20px" width="20px" style='filter: brightness(10%) contrast(200%);')
                            v-img(v-else src="@/assets/images/picture-close.png" max-width="20px" width="20px")
                            div.btn-overlay(v-if="closeImage")
                    v-row.ref-content.mt-1(v-if="!closeImage" :style="`overflow-y: auto; max-height: ${blockHeight} `")
                        v-col.pl-0.pr-2.pt-0.pb-2(v-for="(img,index) in filteredImages(currentReference.doc_image_urls)" :key="index" :cols="index==0 ? 12:6")
                            v-card.related-img-card(elevation='0')
                                v-img(:src="img.doc_image_url" :aspect-ratio="16/9" error @click='openWindowDisplayImage(img)' style="cursor :pointer;")
                                v-card-text.ellipsis.related-img-overlay
                                    v-chip.related-img-label.mr-1(label) {{currentReference.context_id}}
                                    span.text-white(v-if="img.page_num != ''") Page {{img.page_num !='' ?img.page_num:0}},
                                    span.pl-1.text-white(v-if="img.image_num!=''") Image {{img.image_num !=''?img.image_num:0}}
                        v-col(cols='12' style='margin-bottom:0px;')
            //- Image
            v-card-text.px-5.text-scrollbar(v-else)
                v-col.pl-0.pr-2.pt-0.pb-2(v-if="currentReference.doc_image_urls && currentReference.doc_image_urls.length === 0")
                    v-card.related-img-card(elevation='0')
                      img(:src="errorbackImage" :draggable="!disableCopy" style="width:100%; aspect-ratio:16/9; object-fit:cover; cursor :pointer;")
                v-col.pl-0.pr-2.pt-0.pb-2( v-for="(img,index) in currentReference.doc_image_urls" :key="index" :cols="index==0 ? 12:6")
                    v-card.related-img-card(elevation='0')
                        img(:src="img.doc_image_url" @error="handleImageError" @click='openWindowDisplayImage(img)' :draggable="!disableCopy" style="width:100%; aspect-ratio:16/9; object-fit:cover; cursor :pointer;")
                        v-card-text.ellipsis.related-img-overlay
                            //- v-chip.related-img-label.mr-1(label) {{index+1}}
                            span.text-white(:title='img.page_num' v-if="img.page_num != '' ") Page {{img.page_num != '' ?img.page_num:0}},
                            span.text-white.pl-1(:title='img.image_num' v-if="img.image_num!=''") Image {{img.image_num != ''? img.image_num:0}}

</template>

<script>
    import Vue from 'vue';
    import VueMarkdown from 'vue-markdown-v2';
    import MarkdownIt from 'markdown-it';
    import { mapState } from 'vuex';
    import errorbackImage from '@/assets/images/notfundImagexl.jpg';
    import UpGPTPortalDataServices from "@/services/UpGPTPortalDataServices";
    export default Vue.extend({
        props: {
            selectedReference: {
                type: [Object, Array],
                required: true,
            },
            allKnowledgeColor: {
                type: Array,
                require: true,
            },
            allReferences: {
                type: Array,
                require: true,
            },
            selectedQuestionid: {
                type: String
            },
            showRemoveBtn: {
                type: Boolean,
                default: true
            },
            disableCopy: {
                type: Boolean,
                default: false
            }
        },
        components: {
            VueMarkdown,
        },
        async created(){
            this.markdown_cls = new MarkdownIt({ 
                html: true,
                breaks: true,
                linkify: true,
            })
        },
        data() {
            return{
                windowHeight: window.innerHeight,
                copied:false,
                showSingleImage: true,
                closeImage: false,
                errorImg: false,
                errorbackImage: errorbackImage,
                currentReference: this.selectedReference,
                changeReference:[],
                markdown_cls:null,
                reffilters: [
                    {name: 'ALL', key: 'all', active: true},
                    {name: '', key: 'web', active: false},
                    {name: '', key: 'knowledge', active: false},
                ],
                web_ref_count: 0,
                kb_ref_count: 0,
                selected_filter: "all"
            }
        },
        methods: {
            onCloseDialog(){
                this.closeImage = false;
                this.showSingleImage = true;
                this.resetfilter();
                this.$emit("emitPortalDrawer",false)
            },
            resetfilter(){
                this.selected_filter = "all";
                this.reffilters = [
                    {name: 'ALL', key: 'all', active: true},
                    {name: '', key: 'web', active: false},
                    {name: '', key: 'knowledge', active: false},
                ]
            },
            async toggleTypeFilters(filter){
                this.reffilters.forEach(f => {
                    if(f.key == filter.key){
                        filter.active = true;
                        f.active = true;
                        this.selected_filter = filter.key
                    }else{
                        f.active = false;
                    }
                })
            },
            onRemoveChunks(type){
                let used_chunks = [];
                if (type === 'Single') {
                    let removeItem = this.selectedReference;
                    if (removeItem.chunk_id === "bing_search_result") {
                        used_chunks = this.allReferences.filter(item => item.cloud_url !== removeItem.cloud_url);
                    } else {
                        used_chunks = this.allReferences.filter(item => item.chunk_id !== removeItem.chunk_id);
                    }
                } else if (type === 'Multi') {
                    // 分開取一般 chunk_id 與 bing cloud_url
                    let idsToRemove = this.changeReference.filter(item => item.chunk_id !== "bing_search_result").map(item => item.chunk_id);
                    let urlsToRemove = this.changeReference.filter(item => item.chunk_id === "bing_search_result").map(item => item.cloud_url);
                    used_chunks = this.allReferences.filter(item => {
                        if (item.chunk_id === "bing_search_result") {
                            return !urlsToRemove.includes(item.cloud_url);
                        } else {
                            return !idsToRemove.includes(item.chunk_id);
                        }
                    });
                }
                this.$emit("emitPD_remove_chunk",used_chunks);
            },
            copyAnswer(text){
                // text content field
                let contentEl = document.querySelector('.source-type-text-content');
                contentEl.setAttribute('contenteditable', 'true');
                // contentEl.focus();
                let hasTable = contentEl.querySelectorAll('table').length > 0;

                // ---if have table tag use execCommand to copy
                if(hasTable){
                    let range = document.createRange();
                    range.selectNodeContents(contentEl);
                    let selection = window.getSelection();
                    selection.removeAllRanges();
                    selection.addRange(range);
                    document.execCommand('copy');
                    selection.removeAllRanges();
                }else{
                    text = text.replaceAll(/\[([^\]]+)\]/g,'$1').replace(/\*\*(.*?)\*\*/g, '$1')
                    const clipboardData =
                    event.clipboardData ||
                    window.clipboardData ||
                    event.originalEvent?.clipboardData ||
                    navigator.clipboard;
                    clipboardData.writeText(text);
                }
                if(this.copied == false){
                    this.copied = true;
                    setTimeout(()=>{
                        this.copied = false;
                    },1000)
                }
            },
            onOpen(url){
                window.open(url, '_blank');
            },
            openWindowDisplayImage(img){
                // 存到 localStorage
                const storageKey = 'doc_image_url_temp';
                window.localStorage.setItem(storageKey, img.doc_image_url);
                // 開新視窗，不帶 query
                const routeUrl = this.$router.resolve({ path: '/image_url' });
                window.open(routeUrl.href, '_blank');
                // let queryString = {
                //     doc_image_url:img,
                // }
                // let routeUrl = this.$router.resolve(
                //     { 
                //         path: '/image_url',
                //         query:queryString
                //     }
                // )
                // window.open(routeUrl.href, '_blank')
            },
            filteredImages(data){
                return this.showSingleImage ? data.slice(0,1) : data
            },
            viewSingleImage(val){
                this.closeImage = false;
                this.showSingleImage = val;
            },
            closeImageArea(){
                this.closeImage = true;
            },
            getColorFromKnowledgeName(knowledge_name){
                let color_data = this.allKnowledgeColor.find(item=>item.name == knowledge_name);
                return color_data ? color_data.color : 'aliceBlue';
            },
            getWebIcon(url){
                const u = new URL(url);
                let iconpath = u.origin + "/favicon.ico";
                return iconpath;
            },
            onWebIconImgError(e) {
                e.target.src = require("@/assets/images/search_web.svg")
            },
            async getDetailReference(question_id,context_id){
                this.currentReference = this.currentReference.find(item=>item.context_id == context_id);
                if(this.currentReference.display_type === "TEXT" && !this.currentReference.content){
                    await UpGPTPortalDataServices.getReferencecontent(question_id,context_id).then((response)=>{
                        this.currentReference.content = response.data.reference_content;
                        this.currentReference.iscopy = true;
                    }).catch(() => {
                          if (this.currentReference.content) {
                             this.currentReference.content = `#### ${this.$t('PORTAL.MISS_CONTENT_TITLE')} \n ${this.$t('PORTAL.MISS_CONTENT_DETAIL')}`;
                            this.currentReference.iscopy = false;
                          }
                    })
                }
            },
            handleImageError(e){
                e.target.src = errorbackImage;
                this.errorImg = true;
            },
        },
        computed: {
            blockHeight(){
                const { xs } = this.$vuetify.breakpoint
                if (xs) return '450px'
                return '600px';
            },
            compiledMarkdown(){
                // 先把 markdown render 成 HTML，如果沒有內容就直接回傳
                const render_str = this.markdown_cls.render(this.currentReference.content);
                if(!this.currentReference.content) return render_str;

                // 處理 Highlight，排除空字串，並排序先處理長字串
                const highlights = [...this.currentReference.highlight_content]
                    .filter(h => h && h.trim())
                    .sort((a, b) => b.length - a.length);
                // 如果沒有 Highlight，也直接回傳
                if(!highlights.length) return render_str;

                return render_str.replace(/(<[^>]+>)|([^<]+)/g, (match, tag, text) => {
                    if(tag) return tag;

                    // 收集所有匹配位置（highlights 已按長度降序，長詞優先）
                    const matches = [];
                    for(const term of highlights){
                        const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                        const re = new RegExp(escaped, 'g');
                        let m;
                        while((m = re.exec(text)) !== null){
                            matches.push({ start: m.index, end: m.index + m[0].length, term: m[0] });
                        }
                    }

                    if(!matches.length) return text;

                    // 依起始位置排序，同位置取較長者
                    matches.sort((a, b) => a.start - b.start || b.end - a.end);

                    // 去除重疊區間
                    const filtered = [];
                    let lastEnd = 0;
                    for(const m of matches){
                        if(m.start >= lastEnd){
                            filtered.push(m);
                            lastEnd = m.end;
                        }
                    }

                    // 重建字串，在匹配位置插入 span
                    let result = '';
                    let pos = 0;
                    for(const m of filtered){
                        result += text.slice(pos, m.start);
                        result += `<span class="portal-highlight">${m.term}</span>`;
                        pos = m.end;
                    }
                    return result + text.slice(pos);
                });
            },
            ...mapState([
                'isUpsideExtension',
            ]),
            filteredReferences() {
                if (this.selected_filter === 'web') {
                    return this.currentReference.filter(r => r.chunk_id === 'bing_search_result')
                }
                if (this.selected_filter === 'knowledge') {
                    return this.currentReference.filter(r => r.chunk_id !== 'bing_search_result')
                }
                return this.currentReference  // all
            }
        },
        watch: {
            selectedReference: {
                immediate: true,
                handler(newVal){
                    this.currentReference = JSON.parse(JSON.stringify(newVal));
                    this.resetfilter();
                    if(Array.isArray(this.currentReference)){
                        this.web_ref_count = this.currentReference.filter(item => item.chunk_id === "bing_search_result").length;
                        this.kb_ref_count = this.currentReference.filter(item => item.chunk_id !== "bing_search_result").length;
                    }
                }
            },
        },
    })
</script>
<style scoped>
.theme--dark.v-btn.v-btn--disabled .v-icon{
    color: rgba(150, 150, 150, 0.5) !important;
}
.theme--dark.v-btn.v-btn--disabled span{
    color: rgba(150, 150, 150, 0.5) !important;
}
.theme--light.v-card > .v-card__text, .theme--light.v-card > .v-card__subtitle{
    color: #333 !important;
}
.v-navigation-drawer--is-mobile:not(.v-navigation-drawer--close), .v-navigation-drawer--temporary:not(.v-navigation-drawer--close){
    box-shadow: -8px 0px 8px 0px rgba(153, 153, 153, 0.1) !important;
}
.ellipsis-2 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
}
.ellipsis-single {
  display: -webkit-box;
  -webkit-line-clamp: 1; /* 部分舊版瀏覽器需要此設定 */
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}
.ref-content::-webkit-scrollbar {
  width: 6px; /* 調整滾動條寬度 */
}
.ref-content::-webkit-scrollbar-track {
  background:  #F4F4F4 !important;
}
.ref-content::-webkit-scrollbar-thumb {
  background: rgba(153, 153, 153, 0.3) ;
  border-radius: 10px;
}
.btn-overlay{
  position: absolute;
  top: 0;
  left: 20%;
  width: 60%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2); /* 數值越高越深 */
  pointer-events: none; /* 確保不影響點擊事件 */
  border-radius: 3px;
}
.reffilter-default {
    color: #888 !important;
    background-color: #F4F4F4 !important;
    border: 1px solid #e8e8e8 !important;
    font-Family: 'Segoe UI' !important;
    font-Weight: 400 !important;
    font-Size: '10px' !important;
}
.reffilter-active {
    color: #2571C7 !important;
    background-color: #E0EFFE !important;
    border: 1px solid #2571C7 !important;
    font-Family: 'Segoe UI' !important;
    font-Weight: 400 !important;
    font-Size: '10px' !important;
}
</style>